import queryString from 'query-string';
import isEmpty from 'lodash/isEmpty';
import { QueryParameters } from '../interface';
import localizationConstants from 'shared/util/translation/constants';

const firstLevelBreadcrumbs = [
	{ name: localizationConstants.home, link: '/' }
];


const API_CONFIG = {
	baseUrl: `${process.env.REACT_APP_BASE_URL}`,
	path: {
		login: 'auth/login',
		logout: 'logout',
		register: 'auth/register',
		emailVerification: 'auth/email/verify',
		forgetPassword: 'auth/forgot-password',
		resetPassword: 'auth/password/reset',
		profile: 'profile',
		changePassword: 'change-password',
		autoGeneratedLicense: 'graphs/auto-generated-licenses',
		upcomingCreatedLicense: 'graphs/upcoming-created-licenses',
		machineList: 'customer-license/machines',
		machineDetail: 'customer-license',
		companyList: 'phoenix-companies',
		terracloudBackupList: 'terracloud/dir/list',
		terracloudBackupDownload: 'tse-backup/request-download',
		terracloudBackupHistory: 'tse-backup/history',
		downloadRequest: 'tse-backup/request-download',
		downloadLink: 'tse-backup/download-link',
		apiKey: 'api-key',
	},
	sentry: 'https://8224f29afc14413cb0b1a9f0835f57d6@o271772.ingest.sentry.io/5222825'
}

const getUrl = (url: string, params: { [key: string]: any } = {}): string => {
	let urlString = `${API_CONFIG.baseUrl}/${url}`;
	if (params && !isEmpty(params)) {
		urlString += `?${queryString.stringify(params)}`;
	}
	return urlString;
}

const allPermissionMapping: { [key: string]: string; } = {
	customerLicenseMachineList: 'customerLicense.machineIndex',
	customerLicenseMachineRead: 'customerLicense.machineDetail',
	phoenixCompanyList: 'phoenix.companies.index',
	phoenixCompanyRead: 'phoenix.companies.show',
	tseBackupHistoryList: 'tse.history',
	tseDownloadRequestCreate: 'tse.download.request_create',
	tseActiveBackupDataRead: 'tse.download.request_get',
	tseDownloadBackup: 'tse.download',
	apiKeyList: 'api.list',
	apiKeyGenerate: 'api.generate',
}

const searchDropdownOptions = [
	{ name: localizationConstants.all, value: '' },
	{ name: localizationConstants.yes, value: '1' },
	{ name: localizationConstants.no, value: '0' }
];

const statusDropdownOptions = [
	{ name: localizationConstants.all, value: '' },
	{ name: localizationConstants.verified, value: '1' },
	{ name: localizationConstants.pending, value: '0' }
];

const pageOptions: number[] = [15, 30, 50, 100];

const PER_PAGE: number = 15;
const PRIVACY_POLICY_URL = 'https://www.posbill.com/datenschutz';

export {
	API_CONFIG,
	getUrl,
	firstLevelBreadcrumbs,
	allPermissionMapping,
	searchDropdownOptions,
	statusDropdownOptions,
	pageOptions,
	PER_PAGE,
	PRIVACY_POLICY_URL
}
